module.exports = __webpack_public_path__ + "img/SilverMetallic_A.ba84bf24.png";